import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.css";
import "./styles/theme.css";

// ProtectedRoute
import ProtectedRoute from './ProtectedRoute';

// Pages and Components
import Login from "./pages/login";
import Home from "./pages/home";
import Layout from "./components/Layout";
import Locations from "./pages/master/location";
import Viewlocations from "./pages/master/viewlocation";
import AddBusinessLocation from "./pages/master/addLocation";
import UserRoll from "./pages/master/userroll";
import AddRoll from "./pages/master/addRoll";
import EditRoll from "./pages/master/editRole";
import ViewRole from "./pages/master/viewRole";
import User from "./pages/master/user";
import AddUser from "./pages/master/addNewUser";
import ViewUser from "./pages/master/viewUser";
import EditUser from "./pages/master/editUser";
import Designation from "./pages/master/designation";
import AddDesignation from "./pages/master/adddesignation";
import ViewDesignation from "./pages/master/viewdesignation";
import FamilyTree from "./pages/familytree/familytree";
import FamilyCompleteTree from "./pages/familytree/viewfamilyTree";
import CreateFamily from "./pages/familytree/createFamily";
import CreateMember from "./pages/familytree/createmember";
import MembersList from "./pages/familytree/membersList";
import TrustList from "./pages/familytree/trustList";
import EditTrust from "./pages/familytree/editTrust";
import CreateTrust from "./pages/familytree/createTrust";
import Timesheet from "./pages/timesheet/timesheet";
import TimesheetYear from "./pages/timesheet/timesheetyear";
import WeeklyScoreCard from "./pages/reports/weeklysummary";
import Client from "./pages/master/client";
import AddClient from "./pages/master/addClient";
import ViewClient from "./pages/master/viewClient";
import EditClient from "./pages/master/editClient";
import EditLocation from "./pages/master/editLocation";
import FirmList from "./pages/superAdmin/firmList";
import AddFirm from "./pages/superAdmin/addFirm";
import ViewFirm from "./pages/superAdmin/viewFirm";
import EditFirm from "./pages/superAdmin/editFirm";
import Subscriptions from "./pages/superAdmin/subscriptions";
import EditDesignation from "./pages/master/editdesignation";
import AddSubscriptions from "./pages/superAdmin/addSubscriptions";
import EditSubscriptionForm from "./pages/superAdmin/editSubscriptions";
import ViewSubscription from "./pages/superAdmin/viewsubscriptions";
import Bonus from "./pages/master/bonus";
import AddBonus from "./pages/master/addBonus";
import ViewBonus from "./pages/master/viewBonus";
import EditBonus from "./pages/master/editBonus";
import ResetPassword from "./pages/rest";
import EditFamily from "./pages/familytree/editFamily";
import EditMember from "./pages/familytree/editmember";
import ChangePassword from "./pages/changepassword";
import Estate from "./pages/Estate/Estate";
import AddEstate from "./pages/Estate/addEstate";
import EditEstate from "./pages/Estate/editEstate";
import ViewEstate from "./pages/Estate/viewEstate";
import Assets from "./pages/familytree/assets"
import AssetsList from "./pages/master/assets"
import AddAssets from "./pages/master/addassets"
import EditAssets from "./pages/master/editassets"
import EditAsset from "./pages/familytree/editassets"
import MonthScore from "./pages/monthReport/monthlyScorec"
import IncentiveReport from "./pages/monthReport/IncentiveReport"
import ManagementReports from "./pages/monthReport/ManagementReports"
import ProductionSummary from "./pages/reports/productionSummary"
import PayrollSummary from "./pages/reports/payrollSummary"

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Router>
      <Routes>
        {/* Redirect to Home if authenticated, else show Login */}
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/home" /> : <Login />}
        />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/changepassword" element={<ChangePassword />} />

        {/* Protected Routes */}
        {isAuthenticated && (
          <Route element={<Layout />}>
            {/* Main Routes */}
            <Route path="/home" element={<Home />} />

            {/* Locations */}
            <Route path="/location" element={<ProtectedRoute requiredSlug="location-list"><Locations /></ProtectedRoute>} />
            <Route path="/viewlocation" element={<ProtectedRoute requiredSlug="location-view"><Viewlocations /></ProtectedRoute>} />
            <Route path="/addlocation" element={<ProtectedRoute requiredSlug="location-add"><AddBusinessLocation /></ProtectedRoute>} />
            <Route path="/editlocation" element={<ProtectedRoute requiredSlug="location-edit"><EditLocation /></ProtectedRoute>} />

            {/* User Roles */}
            <Route path="/userrole" element={<ProtectedRoute requiredSlug="user-role-list"><UserRoll /></ProtectedRoute>} />
            <Route path="/addRole" element={<ProtectedRoute requiredSlug="user-role-add"><AddRoll /></ProtectedRoute>} />
            <Route path="/editRole" element={<ProtectedRoute requiredSlug="user-role-edit"><EditRoll /></ProtectedRoute>} />
            <Route path="/viewRole" element={<ProtectedRoute requiredSlug="user-role-view"><ViewRole /></ProtectedRoute>} />

            {/* Users */}
            <Route path="/user" element={<ProtectedRoute requiredSlug="user-list"><User /></ProtectedRoute>} />
            <Route path="/adduser" element={<ProtectedRoute requiredSlug="user-add"><AddUser /></ProtectedRoute>} />
            <Route path="/viewuser" element={<ProtectedRoute requiredSlug="user-view"><ViewUser /></ProtectedRoute>} />
            <Route path="/edituser" element={<ProtectedRoute requiredSlug="user-edit"><EditUser /></ProtectedRoute>} />

            {/* Family Tree */}
            {/* <Route path="/familytree" element={<ProtectedRoute requiredSlug="familytree-list"><FamilyTree /></ProtectedRoute>} /> */}
            <Route path="/familytree" element={<ProtectedRoute requiredSlug="familytree-list"><FamilyTree /></ProtectedRoute>} />
            <Route path="/editfamilytree" element={<ProtectedRoute requiredSlug="familytree-edit"><EditFamily /></ProtectedRoute>} />
            <Route path="/editmember" element={<ProtectedRoute requiredSlug="familytree-edit"><EditMember /></ProtectedRoute>} />
            <Route path="/assets" element={<ProtectedRoute requiredSlug="familytree-list"><Assets /></ProtectedRoute>} />

            <Route path="/editassetmember" element={<EditAsset /> }/>
            <Route path="/viewfamilytree" element={<ProtectedRoute requiredSlug="familytree-view"><FamilyCompleteTree /></ProtectedRoute>} />
            <Route path="/createfamily" element={<ProtectedRoute requiredSlug="familytree-add"><CreateFamily /></ProtectedRoute>} />
            <Route path="/createmember" element={<ProtectedRoute requiredSlug="familytree-add"><CreateMember /></ProtectedRoute>} />
            <Route path="/memberslist" element={<ProtectedRoute requiredSlug="familytree-list"><MembersList /></ProtectedRoute>} />
            <Route path="/trustlist" element={<ProtectedRoute requiredSlug="familytree-list"><TrustList /></ProtectedRoute>} />
            <Route path="/createtrust" element={<ProtectedRoute requiredSlug="familytree-list"><CreateTrust /></ProtectedRoute>} />
            <Route path="/edittrust" element={<ProtectedRoute requiredSlug="familytree-list"><EditTrust /></ProtectedRoute>} />

            {/* Estate */}
            <Route path="/estate" element={<ProtectedRoute requiredSlug="estate-list"><Estate /></ProtectedRoute>} />
            <Route path="/addestate" element={<ProtectedRoute requiredSlug="estate-add"><AddEstate /></ProtectedRoute>} />
            <Route path="/editestate" element={<ProtectedRoute requiredSlug="estate-edit"><EditEstate /></ProtectedRoute>} />
            <Route path="/viewestate" element={<ProtectedRoute requiredSlug="estate-edit"><ViewEstate /></ProtectedRoute>} />

            {/* Designation */}
            {/* pending  */}
            <Route path="/designation" element={<ProtectedRoute requiredSlug="designation-list"><Designation /></ProtectedRoute>} />
            <Route path="/adddesignation" element={<ProtectedRoute requiredSlug="designation-add"><AddDesignation /></ProtectedRoute>} />
            <Route path="/viewdesignation" element={<ProtectedRoute requiredSlug="designation-view"><ViewDesignation /></ProtectedRoute>} />
            <Route path="/editdesignation" element={<ProtectedRoute requiredSlug="designation-edit"><EditDesignation /></ProtectedRoute>} />

            {/* Timesheet and Reports */}
              {/* pending  */}
            <Route path="/timesheet" element={<ProtectedRoute requiredSlug="timesheet-list"><Timesheet /></ProtectedRoute>} />
            <Route path="/timesheetyear" element={<ProtectedRoute requiredSlug="timesheet-import"><TimesheetYear /></ProtectedRoute>} />
            <Route path="/weekly-performance" element={<ProtectedRoute requiredSlug="weekly-performance"><WeeklyScoreCard /></ProtectedRoute>} />

            {/* Month and Reports */}
            <Route path="/monthly-scorecard" element={<ProtectedRoute requiredSlug="monthly-scorecard"><MonthScore /></ProtectedRoute>} />
            <Route path="/incentive-report" element={<ProtectedRoute requiredSlug="incentive-report"><IncentiveReport /></ProtectedRoute>} />
            <Route path="/management-reports" element={<ProtectedRoute requiredSlug="management-reports"><ManagementReports /></ProtectedRoute>} />
            <Route path="/production-summary" element={<ProtectedRoute requiredSlug="production-summary"><ProductionSummary /></ProtectedRoute>} />
            <Route path="/payroll-summary" element={<ProtectedRoute requiredSlug="payroll-summary"><PayrollSummary /></ProtectedRoute>} />

            {/* Clients */}
            <Route path="/client" element={<ProtectedRoute requiredSlug="client-list"><Client /></ProtectedRoute>} />
            <Route path="/addclient" element={<ProtectedRoute requiredSlug="client-add"><AddClient /></ProtectedRoute>} />
            <Route path="/viewclient" element={<ProtectedRoute requiredSlug="client-view"><ViewClient /></ProtectedRoute>} />
            <Route path="/editclient" element={<ProtectedRoute requiredSlug="client-edit"><EditClient /></ProtectedRoute>} />

            {/* Firms */}
            <Route path="/firmList" element={<ProtectedRoute requiredSlug="firm-list"><FirmList /></ProtectedRoute>} />
            <Route path="/addfirm" element={<ProtectedRoute requiredSlug="firm-add"><AddFirm /></ProtectedRoute>} />
            <Route path="/ViewFirm" element={<ProtectedRoute requiredSlug="firm-view"><ViewFirm /></ProtectedRoute>} />
            <Route path="/EditFirm" element={<ProtectedRoute requiredSlug="firm-edit"><EditFirm /></ProtectedRoute>} />

            {/* Subscriptions */}
            <Route path="/Subscriptions" element={<ProtectedRoute requiredSlug="subscriptions-list"><Subscriptions /></ProtectedRoute>} />
            <Route path="/AddSubscriptions" element={<ProtectedRoute requiredSlug="subscriptions-add"><AddSubscriptions /></ProtectedRoute>} />
            <Route path="/editSubscriptions" element={<ProtectedRoute requiredSlug="subscriptions-edit"><EditSubscriptionForm /></ProtectedRoute>} />
            <Route path="/viewSubscriptions" element={<ProtectedRoute requiredSlug="subscriptions-view"><ViewSubscription /></ProtectedRoute>} />

            {/* Bonuses */}
            <Route path="/bonus" element={<ProtectedRoute requiredSlug="bonus-list"><Bonus /></ProtectedRoute>} />
            <Route path="/addbonus" element={<ProtectedRoute requiredSlug="bonus-add"><AddBonus /></ProtectedRoute>} />
            <Route path="/viewbonus" element={<ProtectedRoute requiredSlug="bonus-view"><ViewBonus /></ProtectedRoute>} />
            <Route path="/editbonus" element={<ProtectedRoute requiredSlug="bonus-edit"><EditBonus /></ProtectedRoute>} />


            {/* assets */}
            <Route path="/assetslist" element={<ProtectedRoute requiredSlug="asset-list"><AssetsList /></ProtectedRoute>} />
            <Route path="/addasset" element={<ProtectedRoute requiredSlug="asset-add"><AddAssets /></ProtectedRoute>} />
            <Route path="/editasset" element={<ProtectedRoute requiredSlug="asset-edit"><EditAssets /></ProtectedRoute>} />
            {/* <Route path="/assetslist" element={<AssetsList /> }/> */}
            {/* <Route path="/addasset" element={<AddAssets /> }/> */}
            {/* <Route path="/editasset" element={<EditAssets /> }/> */}

          </Route>
        )}

        {/* Redirect unauthenticated users */}
        {!isAuthenticated && <Route path="*" element={<Navigate to="/" />} />}
      </Routes>
    </Router>
  );
};

export default App;



